import React from 'react';
import { FACEBOOK_URL } from '../../data/site';
function FacebookMark({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" data-id="element-777" data-mp="1yjpj1ims4r06">
      <path d="M13.5 21v-7.5h2.5l.4-3h-2.9V8.6c0-.9.3-1.5 1.5-1.5h1.5V4.4c-.3 0-1.2-.1-2.2-.1-2.2 0-3.7 1.3-3.7 3.8v2.4H8v3h2.6V21h2.9Z" data-id="element-778" data-mp="1tqd8udiukmqy" />
    </svg>;
}

/** Diskret link til Facebook-siden — åbner i en ny fane. */
export function FacebookLink({
  label = 'Følg LYKKEVÆRK på Facebook',
  className = ''
}: {
  label?: string;
  className?: string;
}) {
  return <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className={`group inline-flex items-center gap-2 text-ink-soft transition-colors duration-200 ease-smooth hover:text-ink ${className}`} data-id="element-779" data-mp="1asskr8nwps7e">
      <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-ink text-white transition-colors duration-200 ease-smooth group-hover:bg-accent" data-id="element-780" data-mp="355s67ieyxgml">
        <FacebookMark className="h-4 w-4" data-id="element-781" data-mp="wpan5uad96dc" />
      </span>
      {label}
      <span className="sr-only" data-id="element-782" data-mp="wr5cdkso7kn8">(åbner i en ny fane)</span>
    </a>;
}